<template>
  <v-container grid-list-xl>
    <div v-if="!loading">
      <v-layout wrap v-if="toolPickups.length">
        <v-flex xs12 class="headline"
          ><v-btn
            color="primary"
            class="mr-4"
            small
            outlined
            text
            to="/jobs"
            style="margin-top:-3px"
            ><v-icon left>chevron_left</v-icon>Jobs</v-btn
          >
          {{ toolPickups[0].jobSite.street }}
          <span class="caption" v-if="toolPickups"
            >pickup count: {{ toolPickups.length }}</span
          >
          <v-btn
            class="ml-4"
            x-small
            outlined
            color="primary"
            :to="`/jobs/cost/${toolPickups[0].jobSite.id}`"
            >View Cost Report</v-btn
          >
          <v-btn
            class="ml-4"
            x-small
            outlined
            color="primary"
            :to="`/jobs/orders/${toolPickups[0].jobSite.id}`"
            >View Order Summary</v-btn
          >
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="toolPickups"
              :search="search"
              :items-per-page="10"
              :loading="loading"
              loading-text="Loading Tool Pickups..."
              show-expand
              :expanded="toolPickups"
            >
              <template v-slot:item.orderNumber="{ item }">
                <span class="subtitle-2"
                  ><a
                    :href="`/tools/manage/pickups/${item.orderNumber}`"
                    target="_blank"
                    >#{{ item.orderNumber }}</a
                  ></span
                >
              </template>
              <template v-slot:item.jobSite="{ item }">
                <div style="line-height:16px">
                  {{ item.jobSite.street }}
                  <br />
                  <span style="font-size:12px"
                    >{{ item.jobSite.city }}, {{ item.jobSite.state }}
                    {{ item.jobSite.postalCode }}</span
                  >
                </div>
              </template>
              <template v-slot:item.orderedBy="{ item }"
                >{{ item.orderedBy.firstName }}
                {{ item.orderedBy.lastName }}</template
              >
              <template v-slot:item.status="{ item }">
                <v-chip
                  small
                  color="amber lighten-3"
                  v-if="item.status == 'open'"
                  >open</v-chip
                >
                <v-chip
                  small
                  color="red lighten-3"
                  v-if="item.status == 'closed'"
                  >closed</v-chip
                >
                <v-chip small v-if="item.status == 'cancelled'"
                  >cancelled</v-chip
                >
              </template>
              <template v-slot:item.fulfillmentDate="{ item }">
                <div v-if="item.fulfilled">
                  <div class="grey--text" style="font-size:12px;">
                    {{ item.fulfillmentDate.toDate() | moment("MMM Do h:mma") }}
                  </div>
                  <div
                    v-if="item.fulfilledBy"
                    class="grey--text"
                    style="font-size:12px;"
                  >
                    by {{ item.fulfilledBy.firstName }}
                    {{ item.fulfilledBy.lastName }}
                  </div>
                </div>
              </template>
              <template v-slot:item.orderDate="{ item }">{{
                item.orderDate.toDate() | moment("MMM Do [at] h:mma YYYY")
              }}</template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="pa-0">
                  <v-simple-table dense id="sub-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <td width="310">
                            <span class="caption grey--text">Tool Name</span>
                          </td>
                          <td style="width:200px">
                            <span class="caption grey--text"
                              >On Site (at time of request)</span
                            >
                          </td>
                          <td style="width:200px">
                            <span class="caption grey--text">Pickup QTY</span>
                          </td>
                          <td>
                            <span class="caption grey--text">Returned QTY</span>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="tool in item.tools" :key="tool.id">
                          <td>{{ tool.title }}</td>
                          <td>{{ tool.totalQty }}</td>
                          <td>{{ tool.pickupQty }}</td>
                          <td>{{ tool.returnedQty }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-row justify="center" v-if="!loading">
          <v-col class="text-center mt-4 pt-4">
            No tool order data available for this job<br /><br />
            <v-btn color="primary" outlined to="/jobs"
              ><v-icon left>chevron_left</v-icon> Back to jobs</v-btn
            >
          </v-col>
        </v-row>
      </v-layout>
    </div>
    <div v-else>
      <h1 class="display-1 text-center">
        Loading Job Site Date
      </h1>
      <v-text-field color="primary" loading disabled></v-text-field>
    </div>
  </v-container>
</template>
<script>
import fb from "@/main";
import { sumBy, sum } from "lodash";
import utils from "@/helpers/utils";
export default {
  data() {
    return {
      toolPickups: [],
      loading: true,
      search: "",
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
        },
        { text: "Ordered By", value: "fullName" },
        { text: "Order Date", value: "orderDate" },
        // {
        //   text: "Fulfilled By",
        //   value: "fulfillmentDate",

        //   align: "left",
        // },
        { text: "Type", value: "pickupType" },
        { text: "Status", value: "status" },
      ],
    };
  },
  async created() {
    try {
      this.loading = true;
      const toolPickups = await fb.db
        .collection("toolPickups")
        .where("jobSite.id", "==", this.$route.params.id)
        .orderBy("orderDate", "desc")
        .get();
      this.toolPickups = [];
      toolPickups.forEach((u) => {
        this.toolPickups.push({
          fullName: `${u.data().orderedBy.firstName} ${
            u.data().orderedBy.lastName
          }`,
          id: u.id,
          ...u.data(),
        });
      });
      console.log(this.toolPickups);
      this.loading = false;
    } catch (err) {
      console.log(err);
      alert("Error getting orders");
      this.loading = false;
    }
  },
  methods: {},
};
</script>

<style>
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
}

#sub-table td,
#sub-table thead {
  background: #f7f7f7;
}
tr.total-row td {
  background-color: #ececec !important;
}
</style>
